import { useForm } from 'react-hook-form'

import { ContainerForm } from '../../../components/form/ContainerForm'
import { yupResolver } from '@hookform/resolvers/yup'
import { FieldLogin, schema } from './ValidationSchema'
import { Link } from 'react-router-dom'

export default function RegisterPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldLogin>({
    resolver: yupResolver(schema),
  })

  const submit = () => console.log(1)
  return (
    <>
      <form onSubmit={handleSubmit(submit)}>
        <h3>Cadastrar</h3>
        <ContainerForm textBtn='Cadastrar'>
          <div className={`field ${errors.name ? 'error' : ''}`}>
            <label htmlFor='name'>Nome</label>
            <input type='text' id='name' {...register('name')} />
            {errors.name && <p>{errors.name.message}</p>}
          </div>
          <div className={`field ${errors.password ? 'error' : ''}`}>
            <label htmlFor=''>Senha</label>
            <input type='password' {...register('password')} />
            {errors.password && <p>{errors.password.message}</p>}
          </div>
          <div className={`field ${errors.confirmPassword ? 'error' : ''}`}>
            <label htmlFor='confirmPassword'>Confirmação de Senha</label>
            <input type='password' id='confirmPassword' {...register('confirmPassword')} />
            {errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}
          </div>
        </ContainerForm>
      </form>
      <p>
        Já tem um conta <Link to='/users/login'>Clique aqui.</Link>
      </p>
    </>
  )
}
